import { useQuery } from '@tanstack/react-query';

import { getVisitCheckResult } from '@/services/main/rezept/visitCheckService';
import type { VisitCheckResultResponse } from '@/types/visitCheck.types';

import { useClinicContext } from './useClinicContext';

export const useVisitCheckResultQuery = (token: string | null, enabled = true) => {
  const { tenant, clinicNumber } = useClinicContext();

  return useQuery<VisitCheckResultResponse>({
    queryKey: ['visit-check', 'result', token],
    queryFn: () => getVisitCheckResult(tenant, clinicNumber, token as string),
    enabled: enabled && !!token,
    staleTime: 60_000,
  });
};

export default useVisitCheckResultQuery;
